export const MenuItems = [
    {
        title: 'Home',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Probes',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Warnings',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Community',
        url: '#',
        cName: 'nav-links'
    },
    {
        title: 'Help',
        url: '#',
        cName: 'nav-links-mobile'
    },
]